'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createApp = createApp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createApp(store, history, router) {
  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    router
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@dr-kobros/react-broilerplate/lib/app.js
// module id = 680
// module chunks = 0